import * as React from "react";
import { connect } from "react-redux";
import { IReduxState } from "../../../reduxTypes";
import { IAuthState, IToken } from "../../Auth/store/types";
import { Row, Col } from "reactstrap";
import Stats from "./Stats";
import NotificationFeed from "../Notifications/NotificationFeed";
import { Scrollbars } from "react-custom-scrollbars";
import "./home.css";

export interface IHomeProps {
  auth: IAuthState;
  history: any;
  location: any;
}

export interface IHomeState {
  agencyCode: string;
  showScrollLogo: boolean;
}

export class Home extends React.Component<IHomeProps, IHomeState> {
  constructor(props: IHomeProps) {
    super(props);
    this.state = {
      agencyCode: "",
      showScrollLogo: true,
    };
  }
  public componentDidMount() {
    const idToken = this.props.auth.idToken as IToken;
    const agencyCode = idToken.payload["custom:agencyCode"];
    this.setState({ agencyCode });
  }
  public render() {
    return (
      <Row className="container-sidebar ">
        <Col className="col-xs-3 col-md-4 col-lg-3 col-xl-2 col-sm-12 col-xs-12 d-none d-xs-none d-md-block no-padding-right">
          <NotificationFeed lastLogin={this.props.auth.lastLogin} />
        </Col>
        <Col className="col-md-8 col-lg-9 col-xl-10 col-sm-12 home no-padding-left margin-bottom">
          <Scrollbars
            style={{ width: "100%" }}
            autoHide={true}
            autoHideTimeout={1000}
            autoHideDuration={200}
          >
            <Stats {...this.props} />
          </Scrollbars>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(Home);
